export default [
  {
    path: '/incidencias-masivas',
    name: 'incidencias-masivas',
    component: () => import(/* webpackChunkName: "incidencias-masivas" */
      '@/pages/incidencias-masivas/IncidenciasMasivasPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/incidencias-masivas/:id',
    name: 'incidencia-masiva-detalle',
    component: () => import(/* webpackChunkName: "incidencia-masiva-detalle" */
      '@/pages/incidencias-masivas/IncidenciaMasivaDetallePage.vue'),
    meta: { requiresAuth: true }
  }
]
